import React from "react";
import TextField from "@material-ui/core/TextField";
import {MoviePreview} from "../components/movie-preview";

const OneField = ({label, value}) => (
    <TextField
        label={label}
        value={value || undefined}
        margin="normal"
        variant="outlined"
        disabled
    />
);

const FieldsList = ({fields, record}) => (
    <React.Fragment>
        {fields.map( field => <OneField key={field} label={field} value={record[field]} />)}
    </React.Fragment>
);

const defaultReadonlyFields = "_id,original_id,vendorka_id,slug,createdAt,updatedAt,deletedAt".split(',');


export const GenericAside = ({record, children, width=200}) => (
    <div style={{width, margin: '1em'}}>
        {children}

        {record ? (
            <React.Fragment>
                <h6>Readonly Record details</h6>
                <FieldsList fields={defaultReadonlyFields}
                            record={record}/>
            </React.Fragment>
        ) : null}

    </div>
);



export const AsideWithPlayer = ({record, children, ...other}) => (
    <GenericAside record={record} {...other} width="35%">
        <MoviePreview record={record}/>
        {children}
    </GenericAside>
);
